import latao from '../../assets/leagues/latao.png';
import cobre from '../../assets/leagues/cobre.png';
import bronze from '../../assets/leagues/bronze.png';
import prata from '../../assets/leagues/prata.png';
import ouro from '../../assets/leagues/ouro.png';
import safira from '../../assets/leagues/safira.png';
import esmeralda from '../../assets/leagues/esmeralda.png';
import rubi from '../../assets/leagues/rubi.png';
import diamante from '../../assets/leagues/diamante.png';
import ultraRaro from '../../assets/leagues/ultra-raro.png';
import interplanetario from '../../assets/leagues/interplanetario.png';

export const LEAGUE_CONFIG = {
  latao: {
    order: 1,
    name: 'Latão',
    image: latao,
    glow: 'shadow-[0_0_30px_-5px_rgba(217,119,6,0.55)]',
    accent: '#fbbf24',
    requiresPro: false,
  },
  cobre: {
    order: 2,
    name: 'Cobre',
    image: cobre,
    glow: 'shadow-[0_0_32px_-5px_rgba(180,83,9,0.6)]',
    accent: '#fb923c',
    requiresPro: false,
  },
  bronze: {
    order: 3,
    name: 'Bronze',
    image: bronze,
    glow: 'shadow-[0_0_32px_-5px_rgba(161,98,7,0.6)]',
    accent: '#facc15',
    requiresPro: false,
  },
  prata: {
    order: 4,
    name: 'Prata',
    image: prata,
    glow: 'shadow-[0_0_34px_-5px_rgba(148,163,184,0.65)]',
    accent: '#cbd5e1',
    requiresPro: false,
  },
  ouro: {
    order: 5,
    name: 'Ouro',
    image: ouro,
    glow: 'shadow-[0_0_36px_-5px_rgba(234,179,8,0.7)]',
    accent: '#fde047',
    requiresPro: false,
  },
  safira: {
    order: 6,
    name: 'Safira',
    image: safira,
    glow: 'shadow-[0_0_36px_-5px_rgba(2,132,199,0.7)]',
    accent: '#38bdf8',
    requiresPro: true,
  },
  esmeralda: {
    order: 7,
    name: 'Esmeralda',
    image: esmeralda,
    glow: 'shadow-[0_0_38px_-5px_rgba(22,163,74,0.7)]',
    accent: '#4ade80',
    requiresPro: true,
  },
  rubi: {
    order: 8,
    name: 'Rubi',
    image: rubi,
    glow: 'shadow-[0_0_40px_-5px_rgba(220,38,38,0.7)]',
    accent: '#f87171',
    requiresPro: true,
  },
  diamante: {
    order: 9,
    name: 'Diamante',
    image: diamante,
    glow: 'shadow-[0_0_42px_-5px_rgba(6,182,212,0.75)]',
    accent: '#67e8f9',
    requiresPro: true,
  },
  ultraRaro: {
    order: 10,
    name: 'Ultra Raro',
    image: ultraRaro,
    glow: 'shadow-[0_0_46px_-5px_rgba(147,51,234,0.8)]',
    accent: '#c084fc',
    requiresPro: true,
  },
  interplanetario: {
    order: 11,
    name: 'Interplanetário',
    image: interplanetario,
    glow: 'shadow-[0_0_52px_-5px_rgba(236,72,153,0.85)]',
    accent: '#f472b6',
    requiresPro: true,
    cosmic: true,
  },
};

export const LEAGUE_ORDER = [
  'latao',
  'cobre',
  'bronze',
  'prata',
  'ouro',
  'safira',
  'esmeralda',
  'rubi',
  'diamante',
  'ultraRaro',
  'interplanetario',
];

export function getLeagueConfig(id) {
  return LEAGUE_CONFIG[id] || LEAGUE_CONFIG.latao;
}

export function getLeagueOrder(id) {
  return LEAGUE_CONFIG[id]?.order || 1;
}
